import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const FirstSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, 
    threshold: 1, 
  });
  return (
    <section className="f-sec">
      <div className="background">
        <img className="water-f" src="img/water-surface-level-shot-rocks-reefs-sea-sunny-day.jpg" alt="Water Surface" />
        <div className="gradient"></div>
      </div>
      <div className="mob-back"></div>
      <div className="flex">
        <div className="f-left" ref={ref}>
          <div className="no">
            {inView && <CountUp start={0} end={13} duration={2.5} />} 
            <span>MILLION EUROS</span>
          </div>
          <div className="no">
            {inView && <CountUp start={0} end={4} duration={2.5} />} 
            <span>COMMITMENTS</span>
          </div>
          <div className="no">
            {inView && <CountUp start={0} end={1} duration={2.5} />}
            <span>OCEAN</span>
          </div>
        </div>
        <div className="f-right">
          <h2>At the Ηeart of the 9th Our Ocean Conference</h2>
          <p>The protection of the marine environment is central to the Athanasios C. Laskaridis Charitable Foundation’s mission. That is why we participated in this premier international conference dedicated to the oceans. With an active participation in sessions and the organization of two side events, we announced the largest commitments made by a private non-profit organization, totaling 13 million euros. Over the next five years, we will engage in substantial collaborations that will reshape the future of marine areas in Greece and the Mediterranean.</p>
        </div>
      </div>
    </section>

  );
};

export default FirstSection;
